import { history } from 'app/redux/store';
import axios from 'axios';
import { NotificationManager } from 'react-notifications';
import config from '../../config';


axios.interceptors.response.use(response => {
    return response;
}, error => {
    if (error.response.status === 403) {
        console.log(" ****** ana hata yakalamayaya girdi 403");
        NotificationManager.error('Oturmun süresi doldu yeniden giriş yapmanız gerekiyor.')

        localStorage.removeItem("token");
        localStorage.removeItem("user");
        window.location.href = config.mainPageUrl + `?status=false&message=Oturmunuzun süresi dolmuştur. Yeniden giriş yapınız.&code=403`;
    }
    else if (error.response.status === 401) {
        console.log(" ****** ana hata yakalamayaya girdi 401");
        NotificationManager.error('Yetkisiz erişim')
        return { status: false, data: null, messages: "Yetkisiz erişim" }
    }
    else {

        history.push("/404");
    }

    return error;
});




export const postUserOtherAuthCheck = async (data) => {
    const configAxios = {
        headers: { Authorization: "Bearer " + data.token }
    }

    const url = `${config.userCheckApiUrl}`;
    return await axios.post(url, data, configAxios)
        .then(response => response.data);
}


export const postCreateUserApi = async (user) => {
    const token = localStorage.getItem("token");
    const configAxios = {
        headers: { Authorization: "Bearer " + token }
    }
    const url = `${config.userCheckApiUrl}/v1/auth/signUp`;
    return await axios.post(url, user, configAxios)
        .then(response => response.data)
}


export const postLoginUserApi = async (user) => {
    const url = `${config.userAuthApiUrl}/v1/auth/login`;
    return await axios.post(url, user)
        .then(response => response.data)
}








